import { PureConnect, React } from '../../react';
import authSelectors from '../../auth/selectors';
import { selectors as metaSelectors } from '../../meta/selectors';
import windowSelectors from '../../window/selectors';
import LOGIN from '../../auth/actions/LOGIN'; 
import ADMIN_HIDE from '../admin/actions/HIDE'; 
import BUTTON_HIDE_FLYOVER from '../flyover/actions/BUTTON_HIDE_FLYOVER';
import FLYOVER_SHOW from '../flyover/actions/SHOW';
import NOTEMENU_ERASE from '../notemenu/actions/ERASE';
import ADMIN_SHOW from '../admin/actions/SHOW';
import ADMIN_CLOSE from '../admin/actions/HIDE';
import cx from './style.less';
import Wrapper from '../../focuslock/wrapper';
import { buttonBekijkItems, buttonLogin, buttonNoSelection, originFlyover, originNoteMenu, originUndefined } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import UPDATED_BUTTON_LOCK from '../../focuslock/actions/UPDATED_BUTTON_LOCK';
import { Btn } from '../../react-toolbox-redesign/button';

export default PureConnect(`NoteBar`)(
    (state) => ({
        admin: state.admin.visible,
        flyover: state.flyover.visible,
        loggedIn: authSelectors.loggedIn(state),
        notemenu: state.notemenu.visible,
        pageNumber: metaSelectors.pageNumber(state),
        screenSmall: windowSelectors.small(state),
    }),
    (dispatch) => ({
        closeAdminModal: () => dispatch(ADMIN_HIDE({ })),
        closeFlyOverModal: () => dispatch(BUTTON_HIDE_FLYOVER({ })),
        closeNoteServiceMenu: () => {dispatch(NOTEMENU_ERASE({ }));},
        openFlyOverModal: () => dispatch(FLYOVER_SHOW({buttonNo:buttonNoSelection, origin: originFlyover})),     
        requestLogin: () => dispatch(LOGIN({})),
        showAdmin: () => {
            dispatch(ADMIN_SHOW({ }));},
        closeAdmin: () => { 
             dispatch(ADMIN_CLOSE({ }));},
    }),
    ({ loggedIn, admin, flyover, notemenu, screenSmall, requestLogin, openFlyOverModal, closeFlyOverModal, closeAdmin,  showAdmin, closeNoteServiceMenu }) => {        
        if (!loggedIn) {
            return (
                <div className={cx('component', 'section', screenSmall? 'small-section': 'big-section')}>

                    <div className={cx('left')}>
                    {/* WCAG (button):
                    1) no role; they are buttons
                    2) focussable (Tab)
                    3) toggle function: n/a (when true use aria-pressed)
                    4) aria-expanded: yes/no
                    5) aria-haspopup: yes
                    6) aria-labelledby/aria-describedby: ref to label
                    7) icon of button is explained by tekst-> aria-hidden*/}                    
                    <Wrapper thisButtonNo={buttonLogin} 
                        updatedlock={() => UPDATED_BUTTON_LOCK({ buttonNo: buttonLogin, origin: originUndefined})}>
                        <Btn
                            type="button"
                            className={'btn'} 
                            aria-label={'Login notitieservice'}
                            aria-pressed={false}
                            aria-expanded={false}
                            aria-haspopup={false}
                            tabIndex={0}
                            onClick={() => requestLogin() }
                            disabled={false}>
                            <span>Login notitieservice</span>
                        </Btn>                
                    </Wrapper> 
                    </div>
                </div>
            );
        }     
        
        // const closeButton = <button icon="close" className={cx('left')} primary raised onClick={closeAdminModal}>Sluiten</Button>;
        {/* WCAG (button):
        1) no role; they are buttons
        2) focussable (Tab)
        3) toggle function: n/a (when true use aria-pressed)
        4) aria-expanded: yes/no
        5) aria-haspopup: yes
        6) aria-labelledby/aria-describedby: ref to label
        7) icon of button is explained by tekst-> aria-hidden*/}        
        const toggleButton =
        <Btn
            type="button"
            className={'btn'} 
            extraClassNames={'secondary-btn'}
            aria-label={'Mijn items'}
            aria-pressed={admin}
            aria-expanded={admin}
            aria-haspopup={true}
            tabIndex={0}
            onClick={() => { admin ? closeAdmin() : showAdmin(); }}
            disabled={false}>
            <span>Mijn items</span>
        </Btn>;           

        const showHideBtn = 
        <Wrapper thisButtonNo={buttonBekijkItems} 
            updatedlock={() => UPDATED_BUTTON_LOCK( {buttonNo: buttonBekijkItems, origin: originNoteMenu })}
                                    onFocus={closeNoteServiceMenu}>

            <Btn
                type="button"
                className={'btn'} 
                extraClassNames={'secondary-btn'}
                aria-label={'Bekijk items'}
                aria-pressed={flyover}
                aria-expanded={flyover}
                aria-haspopup={true}
                tabIndex={0}
                onClick={() => { flyover ? closeFlyOverModal() : openFlyOverModal(); }}
                disabled={false}>
                <span>{(flyover? 'Verbergen' : 'Notities weergeven')}</span>
            </Btn> 
        </Wrapper>;         

        return (
            <ul className={cx('component', screenSmall? 'small-section': 'big-section')}>
                <li className={cx('left','section')}>
                    {toggleButton}
                </li>     
                <li className={cx('right','section')}>
                    { admin ? null :                                     
                        showHideBtn               
                    }
                </li>
            </ul>
        );
});



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/bar/index.tsx